import { disableScrollDirectionChecker } from "../gHeader/gHeader";
import stickyMenuHtml from "./stickyMenu.hbs";
import "./stickyMenu.css";
class StickyMenuController {
    constructor (container) {
        this.state = {
            menuItems: [],
            windowTop: true,
            currentItem: 0,
            currentItemOffset: 0,
            totalItems: 0,
            horizontalFlow: false,
        }
        this.container = container;
        this.lastScrollY = window.scrollY;
        this.menuTargets = document.querySelectorAll('.js-element--stickyMenuItem');
        
        this.buildMenuItems = this.buildMenuItems.bind(this);
        this.floatingMenuCheck = this.floatingMenuCheck.bind(this);
        this.elementVisibilityCheck = this.elementVisibilityCheck.bind(this);
        this.calculateItemOffsets = this.calculateItemOffsets.bind(this);
        this.checkForMenuHorizonalScroll = this.checkForMenuHorizonalScroll.bind(this);
        this.floatingMenuCheck = this.floatingMenuCheck.bind(this);
        this.renderMenu = this.renderMenu.bind(this);

        this.enableUI();
    }

    enableUI () {
        disableScrollDirectionChecker();
        this.buildMenuItems();
        this.floatingMenuCheck();
        this.renderMenu();
        this.elementVisibilityCheck();
        this.calculateItemOffsets();
        this.checkForMenuHorizonalScroll();
        window.addEventListener('resize', this.checkForMenuHorizonalScroll.bind(this));
        window.addEventListener('scroll', this.elementVisibilityCheck.bind(this))
        this.container.addEventListener('click', this.handleClick.bind(this));
    }

    buildMenuItems () {
        this.menuTargets.forEach((item, index) => {
            this.state.menuItems.push({href: item.id, name: item.dataset.stickyItemName, itemIndex: index});
            this.state.totalItems++
        })

        this.state.totalItems = this.state.menuItems.length - 1;
    }
    
    floatingMenuCheck () {
        const sentinel = this.container.previousElementSibling;
        const observer = new IntersectionObserver(([entry]) => {
                this.container.classList.toggle("isFloating", !entry.isIntersecting);
            }, {
                root: null,
                rootMargin: '-131px 0px 0px 0px',
                threshold: 0
            }
        );

        observer.observe(sentinel);
    }

    elementVisibilityCheck () {
        if (window.scrollY === 0) {
            this.state.windowTop = true;
            this.renderMenu();
            return;
        } else { 
            this.state.windowTop = false;
        }
        
        this.lastScrollY = window.scrollY;

        const observer = new IntersectionObserver((entries) => {            
            const visibleEntries = entries.filter(entry => entry.isIntersecting);

            if (visibleEntries.length === 0) return;

            // Sort by position on page (top value)
            visibleEntries.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

            // Scrolling down: pick the lowest entry (last in sorted list)
            // Scrolling up: pick the highest entry (first in sorted list)
            const scrollingDown = window.scrollY >= this.lastScrollY;
            const target = scrollingDown ? visibleEntries[visibleEntries.length - 1] : visibleEntries[0];
            const matchedItem = this.state.menuItems.find(item => item.href === target.target.id);
            
            if (matchedItem) {
                this.state.currentItem = matchedItem.itemIndex;
                this.state.currentItemOffset = matchedItem.itemOffset;
                this.renderMenu();
            }
        }, {
            root: null,
            rootMargin: '0px 0px -60% 0px',
            threshold: 0
        });

        this.menuTargets.forEach((target) => {
            observer.observe(target);
        })
    }

    calculateItemOffsets () {
        const menuItemEls = this.container.querySelectorAll('.stickyMenu-nav-list li');
        let cumulativeWidth = 0;

        menuItemEls.forEach((el, index) => {
            if (this.state.menuItems[index]) {
                this.state.menuItems[index].itemOffset = cumulativeWidth;
            }

            cumulativeWidth += el.getBoundingClientRect().width + 16;
        });
    }

    checkForMenuHorizonalScroll () {
        let menuWidth = this.container.querySelector('.stickyMenu-nav').clientWidth;
        let listWidth = this.container.querySelector('.stickyMenu-nav-list').scrollWidth;

        if (menuWidth < listWidth) {
            this.state.horizontalFlow = true;
        } else {
            this.state.horizontalFlow = false;
        }

        this.renderMenu();
    }

    handleClick (e) {
        if (e.target.matches('.js--action-stickyMenu-nav-arrowLeft')) {
            this.state.currentItem = this.state.currentItem - 1
        }
        if (e.target.matches('.js--action-stickyMenu-nav-arrowRight')) {
            this.state.currentItem = this.state.currentItem + 1
        }

        this.state.currentItemOffset = this.state.menuItems[this.state.currentItem].itemOffset;
        document.getElementById(this.state.menuItems[this.state.currentItem].href).scrollIntoView();
    }

    renderMenu () {
        this.container.innerHTML = stickyMenuHtml(this.state);
    }
}

export default StickyMenuController;